import 'css-chunksrc/client/common/projectSection/project/tagList/styles.scss';export default {
  "tagList": "_tagList_de5j2_1",
  "list": "_list_de5j2_8",
  "buttonWrapper": "_buttonWrapper_de5j2_17",
  "tags": "_tags_de5j2_23",
  "hiddenTagsNbr": "_hiddenTagsNbr_de5j2_31",
  "form": "_form_de5j2_46",
  "icon": "_icon_de5j2_54"
};